export function initialPageOrder(count) {
    return Array.from({ length: count }, (_, index) => index + 1);
}

export function movePdfPage(order, from, to) {
    if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || to < 0 || from >= order.length || to >= order.length || from === to) return order;
    const next = order.slice();
    const [page] = next.splice(from, 1);
    next.splice(to, 0, page);
    return next;
}
